import changeset from 'changeset';
import { DesignModuleNode } from '../../../types';
import { getInputsFromAllTexts } from '../prompt';
import { Normalizer } from './normalize-object-or-node';
import { sortByProp } from '../array';

export const normalizePrompt: Normalizer = (node, serialized, appModule) => {
  if (!appModule) {
    return node;
  }

  const { isOmniChannel } = serialized.omniChannel;
  let inputsFromText = getInputsFromAllTexts({
    errorQuietly: serialized !== window.apm?.serialized,
    isOmniChannel,
    localVariables: appModule.localVariables,
    node: node as DesignModuleNode,
    serialized
  });

  const { config } = node.props;

  if (!inputsFromText.length && !config?.inputs?.length) {
    return node;
  }

  /**
   * We don't care if the inputs are in different order, but the changset function will.
   */
  const diff = changeset(
    config?.inputs?.sort(sortByProp('argumentName')) ?? [],
    inputsFromText.sort(sortByProp('argumentName'))
  );

  if (!diff.length) {
    return node;
  }

  const hasInputs = inputsFromText.length > 0;
  const newConfig = {
    inputs: inputsFromText,
    dynamic: hasInputs,
    allowFallbackDomain: hasInputs
  };
  node.props.config = { ...node.props.config, ...newConfig };
  node.props.lastLocalChange = window?.apm?.timestamp ?? Date.now();

  const parentObject = serialized.components.objects.find((object) =>
    object.id === node.props.parentComponentID
  );
  if (parentObject) {
    parentObject.props.config = { ...parentObject.props.config, ...newConfig };
    parentObject.props.lastLocalChange = window?.apm?.timestamp ?? Date.now();
  } else {
    console.warn(`Prompt node ${node.name} (${node.id}) does not have a parent object.`);
  }

  return node;
};
